import React from "react";
import Footer from "../../components/modules/Footer";
import Navbar from "../../components/modules/Navbar";
import './braceletStyles.css'
import {BsFileArrowDown} from 'react-icons/bs'
import { Link as LinkScroll} from 'react-scroll';
import payInTech from '../../assets/partenaires/payintech.png'
import {RiRefund2Fill} from 'react-icons/ri'
import {AiOutlineDollarCircle} from 'react-icons/ai'
import {TbRecharging} from 'react-icons/tb'
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPluging from 'gsap/ScrollToPlugin'
import gsap from 'gsap';
import {useEffect} from 'react'
import { isMobile} from 'react-device-detect';
import { useTranslation} from "react-i18next";



gsap.registerPlugin(ScrollTrigger,ScrollToPluging);




const Bracelet = () =>{
    const { t } = useTranslation('common');

    const FadeBottom = (elem)=>{
            
        gsap.fromTo(
            elem,
            
            {
              y:100,
                opacity:0,
                
    
            },
            {
                opacity:1,
               y:0, 
               
                duration:0.8,
                scrollTrigger:{
                    trigger:elem,
                    start:"-50% 80%",
                    end:"bottom center",
                    toggleActions:"play none none none",
                    
                },
                
            }
           
        )
        
    }

 
    const FadeLeft = (elem)=>{
            
        gsap.fromTo(
            elem,
            
            {
              x:-50,
                opacity:0,
                
    
            },
            {
                opacity:1,
               x:0, 
               
                duration:0.8,
                scrollTrigger:{
                    trigger:elem,
                    start:"-50% 80%",
                    end:"bottom center",
                    toggleActions:"play none none none",
                    
                },
                
            }
           
        )
        
    }

    const FadeRight = (elem)=>{
            
        gsap.fromTo(
            elem,
            
            {
              x:50,
                opacity:0,
                
    
            },
            {
                opacity:1,
               x:0, 
               
                duration:0.8,
                scrollTrigger:{
                    trigger:elem,
                    start:"-50% 80%",
                    end:"bottom center",
                    toggleActions:"play none none none",
                    
                },
                
            }
           
        )
        
    }

    useEffect(()=>{
        const xValue = isMobile ? 0 : -100;
    FadeBottom('#center-card')
    FadeLeft('#left-card')
    FadeRight("#right-card")
        gsap.fromTo(
            "#bracelet-content",
            {
                x: 0,
                opacity: 0,
            },
            {
                opacity: 1,
                x: xValue,
                duration: 0.8,
                scrollTrigger: {
                    trigger: "#bracelet-content",
                    start: "-50% 80%",
                    end: "bottom center",
                    toggleActions: "play none none none",
                },
            }
        )
    FadeBottom('#bracelet-perte')
        },[])

    return (
        <div>
            <Navbar color='#f8485e'/>
            <div className="bracelet">
                <div className="bracelet-title">
                    <h1>{t('cashless.title')}</h1>
                    <LinkScroll to='presentation' smooth={true}  offset={-10} duration={1000}> <BsFileArrowDown style={{color:'#56555a'}} className='fleche-mazars'/></LinkScroll>

                </div>
                <div className="bracelet-presentation" id='presentation'>
                    <h4>
                    {t('cashless.firstP')}
                    </h4>

                </div>
                <div className="bracelet-content">
                    <div className="bracelet-images">
                        <img  src={payInTech} alt="" />
                    </div>
                    <h3> {t('cashless.sndP2')} <span>Payintech ©</span>{t('cashless.sncP3')} <span>{t('cashless.bold3')}</span> {t('cashless.sndP4')}</h3>
                    <div className='bracelet-numbers field'>
                            <div id='left-card'>
                                <h4> {t('cashless.card1')}</h4>
                                <TbRecharging className="icon"/>
                            </div>
                            <div id='center-card'> 
                            <h4> {t('cashless.card2')}</h4>
                            <RiRefund2Fill className="icon"/>
                            </div>
                            <div id='right-card'>
                            <h4> {t('cashless.card3')}</h4>
                            <AiOutlineDollarCircle className="icon"/>
                            </div>

                        
                     </div>
                     <div>
                        <h3> {t('cashless.thirdP')} <span>{t('cashless.bold4')}</span> {t('cashless.thirdP2')}</h3>
                     </div>

                </div>
                <div className="bracelet-recup">
                   
                    <h2>
                    {t('cashless.title2')}
                    </h2>
                    <div className="bracelet-container">
                        <div className="bracelet-img"> </div>
                        <div className="bracelet-recup-content" id='bracelet-content'>
                             <p> {t('cashless.fourthP')}</p>
                             <p> {t('cashless.fiveP')}</p>
                             <p> {t('cashless.sixP')}</p>
                        </div>
                    </div>
                
                </div>
                <div className="bracelet-perte">
                    <h2> {t('cashless.title3')}</h2>
                    <p id='bracelet-perte'>
                    {t('cashless.sevenP')}
                    </p>

                </div>
                                

            </div>
            <Footer color='#f8485e' color2='rgb(222 45 67)'/>
        </div>
    )

}

export default Bracelet